const RESET_PASSWORD_PREFIX = '/resetPassword/';
const RESET_PASSWORD_ROUTE = '/resetPassword';
const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

const normalizeToken = (rawToken) => {
  try {
    return decodeURIComponent(rawToken).trim();
  } catch {
    return null;
  }
};

// The token stays in the URL for the whole flow: it is the one place that
// survives a reload, a service-worker update or a browser with storage blocked.
// The page reads it from the route on every mount instead of holding a copy.
export const parsePasswordRecoveryLink = ({ pathname = '', search = '' } = {}) => {
  const rawToken = pathname.startsWith(RESET_PASSWORD_PREFIX)
    ? pathname.slice(RESET_PASSWORD_PREFIX.length)
    : '';
  const token = normalizeToken(rawToken);
  const tokenIsValid = TOKEN_PATTERN.test(token || '');

  return {
    token: tokenIsValid ? token : null,
    status: tokenIsValid ? null : 'malformed',
    mode: new URLSearchParams(search).has('create') ? 'create' : 'recovery',
  };
};

export const isPasswordRecoveryRoute = (pathname = window.location.pathname) =>
  pathname === RESET_PASSWORD_ROUTE || pathname.startsWith(RESET_PASSWORD_PREFIX);

export const sanitizePasswordRecoveryPath = (pathname, search = '') =>
  isPasswordRecoveryRoute(pathname) ? RESET_PASSWORD_ROUTE : `${pathname}${search}`;
